import { type IconTypes } from '@procurify/ui'

import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationCartActionIcons = {
  CONTINUE: 'pointer-right',
  EXTERNAL: 'link',
} as const satisfies Record<string, IconTypes>

export type ConversationCartActionIconEnum = Enum<
  typeof ConversationCartActionIcons
>
